<style scoped>
.header {
  min-width: 1200px;
  width: 100%;
  height: 70px;
  background: #313541;
}

.header-cont {
  width: auto;
  margin: 0 0 0 30px;
}

.header-cont > .logo {
  float: left;
  width: 36px;
  margin: 15px 0;
}
.header-cont > .logoTitle {
  float: left;
  padding-left: 15px;
  font-size: 22px;
  color: white;
  padding-top: 15px;
}
.header-cont > .logo img {
  width: 100%;
}
.tag {
  float: left;
  padding-top: 20px;
  padding-left: 15px;
}
.header-cont .el-tag {
  background-color: #2ECFA7;
  padding: 0 10px;
  height: 30px;
  line-height: 28px;
  font-size: 12px;
  color: #2ECFA7;
  border-radius: 0px 18px 18px 18px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #2ECFA7;
  white-space: nowrap;
}
.area {
  color: white;
  font-size: 18px;
  font-weight: bold;
}
.storeName {
  color: #fff;
  font-size: 14px;
  /* font-weight: bold; */
}
.header-cont .right-nav {
  width: 45%;
  float: right;
  /* margin-left: 118px; */
  border-left: 1px solid #434756;
}

.header-cont .right-nav li {
  height: 70px;
  width: 25%;
  float: left;
  margin: auto 0;
  line-height: 70px;
  padding: 0 !important;
  /* background: url(../../assets/images/store/left.png) no-repeat left center; */
}
/* .header-cont .right-nav li:first-child{
  background: none;
} */

.header-cont .right-nav li > a {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: #fff !important;
  font-weight: bold;
  text-align: center;
}
.header-cont .right-nav li > a::after{
  transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
}

.header-cont .right-nav li > a:hover {
  /* color: #4389f5 !important; */
  font-weight: bold;
}
.header-cont .right-nav li > a:hover::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 12px;
  left: 0;
  bottom: 0px;
  background: url(../../assets/images/store/sanjiao.png) no-repeat center;
}
.header-cont .right-nav li > a.active{
  background: #3b404f;
}
.header-cont .right-nav li > a.active::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 12px;
  left: 0;
  bottom: 0px;
  background: url(../../assets/images/store/sanjiao.png) no-repeat center;
}
.router-link-active {
  color: #fff !important;
  font-weight: bold;
  /* background: #3b404f; */
  position: relative;
}
.router-link-active::after{
  content: '';
  position: absolute;
  width: 100%;
  height: 12px;
  left: 0;
  bottom: 0px;
  background: url(../../assets/images/store/sanjiao.png) no-repeat center;
}
.header-cont .right-nav .nav-active {
  color: #fff;
  font-weight: bold;
}
.header-cont .operat{
  background: #4293EF;
}
.header-cont .operat1{
  background: #2ECFA7;
}
.header-cont .operat2{
  background: #F96479;
}
.header-cont .operat3{
  background: #FDBB57;
}
.header-cont .operat4{
  background: #8080ff;
}
.header-info {
  float: left;
  cursor: pointer;
  position: relative;
  height: 40px;
  margin: 15px 0;
  box-sizing: border-box;
  padding:6px 10px 6px 20px;
}
.header-info > .current {
  color: #a6abbc;
  float: left;
}
.header-info > .header-img {
  width: 16px;
  height: 18px;
  overflow: hidden;
  float: left;
}

.header-info > .header-img > img {
  width: 100%;
}

.username {
  float: left;
  /* line-height: 32px; */
  margin: auto 10px;
  margin-top: -4px;
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.header-info > i {
  margin: 4px 0;
  float: left;
}
.setStyle {
  float: right;
  background-color: white;
  height: 66px;
}
.header .el-dropdown {
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 14px;
  margin: 20px 15px;
}
/* 下拉隐藏 */
.myHeaderTab .changebtns {
  width: 55px;
  height: 47px;
  cursor: pointer;
  position: absolute;
  /* bottom: -42px; */
  right: 110px;
  top: 65px;
  background: url(../../assets/images/store/btn_topmenu_packup.png) no-repeat center;
  background-size: contain
}

.myHeaderTab .changebtns.downer {
  top: -2px;
  background: url(../../assets/images/store/btn_topmenu_expand.png) no-repeat center;
  background-size: contain
}
.myHeaderTab.el-menu--collapse{
  width: 100%;
}
.myHeaderTab.el-menu--collapse .header{
  min-width: 100%;
  width: 100%;
  height: 4px;
  overflow: hidden;
}
.myHeaderTab.el-menu--collapse .setStyle{
  background: none;
}

.curVoice{
  color:#66B1FF;
}

</style>
<template>
  <el-menu class="myHeaderTab" :default-active="$route.path" :collapse="isHeaderCollapse" @select="selectTab">
      <div class="changebtns" v-if="$route.meta.parent == 'operatingFloor'" :class="{'downer':isHeaderCollapse}" @click="toogleColls"></div>
      <div class="header">
          <div class="header-cont">
              <span class="logo">
                  <img src="../../assets/images/store/logo_tingmei.png" v-if="$store.state.userInfo.brandId == 1">
                  <img src="../../assets/images/store/logo_zhenyoutang.png" v-else-if="$store.state.userInfo.brandId == 2">
                  <img src="../../assets/images/shopping/meiboshi.png" v-else>
              </span>
              <span class="logoTitle">{{$store.state.userInfo.brandId == 1 ? '婷美摩力21产后恢复' : ($store.state.userInfo.brandId == 2 ? '臻幼堂' : '槑博士婴幼儿草本浴')}}</span>
              <span class="tag">
                  <el-tooltip class="item" effect="dark" :content="$store.state.userInfo.storeName" placement="bottom" v-if="$store.state.userInfo.storeName && $store.state.userInfo.storeName.length > 8">
                    <!-- <el-tag ><span class="area">苏州•</span><span class="storeName">金山店</span></el-tag> -->
                    <el-tag><span class="storeName">{{$store.state.userInfo.storeName && $store.state.userInfo.storeName.length > 8 ? $store.state.userInfo.storeName.substr(0,8)+'...':$store.state.userInfo.storeName}}</span></el-tag>
                  </el-tooltip>
                  <el-tag v-else><span class="storeName">{{$store.state.userInfo.storeName && $store.state.userInfo.storeName.length > 8 ? $store.state.userInfo.storeName.substr(0,8)+'...':$store.state.userInfo.storeName}}</span></el-tag>
              </span>
              <div style="float: right;height: 70px;background: #3b404f;">
                <div class="header-info">
                  <span class="current">当前登录：</span>
                  <span class="header-img">
                      <img src="../../assets/images/store/icon_login_user.png">
                  </span>
                  <span class="username">收银员{{$store.state.userInfo.staffName}}</span>
                </div>
                <div class="setStyle">
                  <!--个人中心弹框-->
                    <el-dropdown>
                      <div>
                        <i><img src="../../assets/images/store/icon_set.png" alt=""></i>
                        <span class="el-dropdown-link">
                            设置
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                      </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                @click.native="logout"
                                v-loading.fullscreen.lock="fullscreenLoading">
                              <div>
                                <i><img src="../../assets/images/store/icon_set_quit.png"></i>
                                退出系统
                              </div>
                            </el-dropdown-item>
                            <el-dropdown-item  @click.native="setpsd">
                              <div>
                                <i><img src="../../assets/images/store/icon_set_changekey.png" alt=""></i>
                                修改密码
                              </div>
                            </el-dropdown-item>
                            <el-dropdown-item @mouseenter.native="currentItem" @mouseleave.native="defaultItem" @click.native="setVoice">
                              <div :class="{'curVoice':$store.state.userInfo.setVoiceStatus}">
                                <i>
                                  <img v-if="$store.state.userInfo.setVoiceStatus" src="../../assets/images/store/yuyin.png" width="20" alt="">
                                  <img v-else :src="yuyinImg" width="20" alt="">
                                </i>
                                语音提示
                              </div>
                            </el-dropdown-item>
                            <!-- <el-dropdown-item
                                @click.native="instrument">
                                <div>
                                  <i><img src="../../assets/images/store/icon_set_repair.png"></i>
                                  仪器报修
                                </div></el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="right-nav">
              <el-menu-item index="1" class="operat" v-if="operaCenter"><router-link to='/operatingFloor'>操作台</router-link></el-menu-item>
              <el-menu-item index="2" class="operat1" v-if="businessCenter"><router-link to='/businessManagementCenter'>商品管理</router-link></el-menu-item>
              <el-menu-item index="3" class="operat2" v-if="financeCenter"><router-link to='/financeManageCenter'>财务管理</router-link></el-menu-item>
              <!-- <el-menu-item index="6"><router-link to='/shoppingMall'>采购商城</router-link></el-menu-item> -->
              <!-- <el-menu-item index="6"><router-link to='/reportCenter'>报表中心</router-link></el-menu-item> -->
              <el-menu-item index="4" class="operat3" v-if="basicCenter"><router-link to='/basicDataCenter'>门店管理</router-link></el-menu-item>
              <!-- <el-menu-item index="4" class="operat4"><router-link to='/cliqueBusinessCenter'>集团业务</router-link></el-menu-item> -->
            </div>
          </div>
      </div>
  </el-menu>
</template>
<script>
import {outStore, toLoginOut, oeprateStaffVoice} from '@/api'
export default {
  data() {
    return {
      yuyinImg:require('../../assets/images/store/yuyin1.png'),
      fullscreenLoading: false,
      tabFlag: false,
      isHeaderCollapse: false,
      basicCenter:false,
      businessCenter:false,
      operaCenter:false,
      financeCenter:false,
      cliqueBusinessCenter:false
    };
  },
  created () {
    this.computedList();
  },
  watch: {
    '$store.state.resourceList'(){
      this.computedList();
    }
  },
  methods: {
    computedList(){
      this.basicCenter = false;
      this.businessCenter = false;
      this.operaCenter = false;
      this.financeCenter = false;
      this.cliqueBusinessCenter = false;
      for(let i of this.$store.state.resourceList){
        if(i.url.indexOf('/businessManagementCenter') != -1){
          this.businessCenter = true;
        }else if(i.url.indexOf('/basicDataCenter') != -1){
          this.basicCenter = true;
        }else if(i.url.indexOf('/operatingFloor') != -1){
          this.operaCenter = true;
        }else if(i.url.indexOf('/financeManageCenter') != -1){
          this.financeCenter = true;
        }else if(i.url.indexOf('/cliqueBusinessCenter') != -1){
          this.cliqueBusinessCenter = true;
        }
      }
    },
    selectTab(key, keyPath) {
      setTimeout(() => {
        // if(this.$route.meta.parent != 'baseInfo'){
        //   return;
        // }

      if(key == 2 || key == 3){
        let curName = this.$route.path.split("/")[2],
          parentName = this.$route.meta.parent;
        let myAllroute =
          key == 3 ? this.$router.options.routes[4]:this.$router.options.routes[5]
        this.$store.state.options = [];
        if (myAllroute) {
          myAllroute.children.forEach((i, index) => {
            if (curName === i.meta.parent) {
              this.$store.state.options.push({
                route: i.path,
                name: i.name,
                parent: i.meta.parent
              });
            } else {
              return;
            }
          });
        }
        this.$emit("tabFlag", true);
      }

      });
    },
    toogleColls(){
      if(this.isHeaderCollapse){
        this.isHeaderCollapse = false;
      }else{
        this.isHeaderCollapse = true;
      }
    },
    //注销
    logout() {
      //删除cookie并跳到登录页
      this.fullscreenLoading = true;
      if(this.$store.state.userInfo.storeList && this.$store.state.userInfo.storeList.length > 0){
        // 老板账号
        outStore().then(res=>{
          setTimeout(() => {
            this.fullscreenLoading = false;
            this.$router.push("/allStore");
          },500)
        })
      }else{
        this.delCookie("session");
        //演示
        toLoginOut().then(res=>{
          setTimeout(() => {
            this.fullscreenLoading = false;
            this.$router.push("/login/");
          },500)
        })
      }
      if(this.$store.state.userInfo.setVoiceStatus){
        this.setVoiceMp3(false,this.$store.state.userInfo.staffId);
      }
    },
    gohome() {
      setTimeout(() => {
        this.fullscreenLoading = false;
        this.$router.push("/operatingFloor");
      }, 500);
    },
    setpsd() {
      this.$router.push("/setpsd");
    },
    instrument() {
      // 仪器保修
      this.$router.push("/instrument");
    },
    currentItem(){
      this.yuyinImg = require('../../assets/images/store/yuyin.png')
    },
    defaultItem(){
      this.yuyinImg = require('../../assets/images/store/yuyin1.png')
    },
    setVoice(){
      oeprateStaffVoice({
        staffId:this.$store.state.userInfo.staffId,
        isOpen:this.$store.state.userInfo.setVoiceStatus?0:1
      }).then(res=>{
        if(res.code == 1){
          if(this.$store.state.userInfo.setVoiceStatus){
            this.setVoiceMp3(false,this.$store.state.userInfo.staffId);
            this.$message({
              message: '语音提示已关闭',
              type: 'warning'
            });
          }else{
            this.setVoiceMp3(true,this.$store.state.userInfo.staffId);
            this.$message({
              message: '语音提示已开启',
              type: 'success'
            });
          }
          userInfo.setVoiceStatus = this.$store.state.userInfo.setVoiceStatus?0:1;
          this.$store.commit("updateUserInfo", userInfo);
        }
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/Header.vue